import { Helmet } from "react-helmet";
import assetsConfig from "../../assetsConfig";
import { useEffect, useRef } from "react";
import useHubspotTracking from "../../hooks/useHubspotTracking";
import { useLocation } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";

export const titleDivider = " | ";

const BrowserHeader = ({
	title,
	noPageTracking,
}: {
	title: string;
	noPageTracking?: boolean;
}) => {
	const pageTitle = title + titleDivider + assetsConfig.companyName;
	const { trackPageView } = useHubspotTracking();
	const location = useLocation();
	const currentPath = location.pathname;
	const currentPathParams = location.search;

	// add small delay to allow document title to update
	useDebounce(
		() => {
			if (!noPageTracking) {
				// console.log(
				// 	"tracking page view:",
				// 	pageTitle,
				// 	currentPath + currentPathParams
				// );
				trackPageView(pageTitle, currentPath + currentPathParams);
			}
		},
		300,
		[pageTitle, currentPath, currentPathParams]
	);

	return (
		<Helmet>
			<title>{title + titleDivider + assetsConfig.companyName}</title>
		</Helmet>
	);
};

export default BrowserHeader;
